<template>
	<div>
		<!-- banner -->
		<div class="home-banner">
			<div class="home-contactus-box">
				<div class="home-contactus"  @click="elasticFun">联系我们</div>
				<!-- 方案 -->
				<div class="programme">
					<div class="home-view-model" v-for="(item, index) in titleData" :key="index">
						<div class="home-icon-imgs"><img :src="item.imgs" alt="" /></div>
						<div class="home--model-texts">
							<div class="home-texts1">{{ item.texts1 }}</div>
							<div class="home-texts2">{{ item.texts2 }}</div>
						</div>
					</div>
				</div>
			</div>
		
		</div>
		<!-- 我们的产品 -->
		<div class="our-products">
			<div class="our-products-box">
				<div class="our-products-titles">我们的产品</div>
				<div class="our-products-english">OUR PRODUCTS</div>
			</div>
			<div class="home-Solution-box">
				<div v-for="(item, indexs) in SolutionList" :key="indexs" @click="solutFun(indexs)"
					@mouseover="mouseOverFun(indexs)" @mouseleave="mouseLeaveFun(indexs)">
					<div class="suouttext" :class="num == indexs + 1?'suouttext-active':'suouttext'">{{ item }}</div>

					<div class="home-Underline" v-if="num == indexs + 1"></div>
				</div>
			</div>
		</div>
		<!-- 项目盒子 -->
		<div class="home-back">
			<div class="project-show" v-if="a1===num">
				<div class="home-project" v-for="(item, index) in projectList1" :key="index"
					@mouseover="mouseOverList(index)" @mouseleave="mouseLeaveList(index)">
					<div class="home-project-box" :class="
							  isShow === index? 'home-project-box-active' : 'home-project-box'">
						<div class="home-img-gift"><img :src="item.img" alt="" /></div>
						<div class="projectNames">
							<div class="projectTexts"
								:class="isShow === index  ? 'projectText-active' : 'projectTexts'">
								{{ item.projectNames }}
							</div>
							<div class="home-protitles"
								:class="isShow === index ? 'home-protitles-active' : 'home-protitles'">
								{{ item.titles }}
							</div>
						</div>
						<div class="home-bottom-flex">
							<div class="bottom-text" :class="isShow === index ? 'bottom-textactive' : 'bottom-text'">
								{{ item.leftText }}
							</div>
							<div class="bottom-text" :class="isShow === index ? 'bottom-textactive' : 'bottom-text'">
								{{ item.rightText }}
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 第二个 -->
			<div class="project-show" v-if="a2===num">
				<div class="home-project" v-for="(item, index) in projectList2" :key="index"
					@mouseover="mouseOverList(index)" @mouseleave="mouseLeaveList(index)">
					<div class="home-project-box" :class="
							  isShow === index? 'home-project-box-active' : 'home-project-box'">
						<div class="home-img-gift"><img :src="item.img" alt="" /></div>
						<div class="projectNames">
							<div class="projectTexts"
								:class="isShow === index  ? 'projectText-active' : 'projectTexts'">
								{{ item.projectNames }}
							</div>
							<div class="home-protitles" :class="
							      isShow === index? 'home-protitles-active' : 'home-protitles'
							    ">
								{{ item.titles }}
							</div>
						</div>
						<div class="home-bottom-flex">
							<div class="bottom-text" :class="isShow === index ? 'bottom-textactive' : 'bottom-text'">
								{{ item.leftText }}
							</div>
							<div class="bottom-text" :class="isShow === index ? 'bottom-textactive' : 'bottom-text'">
								{{ item.rightText }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 第三个 -->
			<div class="project-show" v-if="a3===num">
				<div class="home-project" v-for="(item, index) in projectList3" :key="index"
					@mouseover="mouseOverList(index)" @mouseleave="mouseLeaveList(index)">
					<div class="home-project-box" :class="
						  isShow === index? 'home-project-box-active' : 'home-project-box'">
						<div class="home-img-gift"><img :src="item.img" alt="" /></div>
						<div class="projectNames">
							<div class="projectTexts"
								:class="isShow === index  ? 'projectText-active' : 'projectTexts'">
								{{ item.projectNames }}
							</div>
							<div class="home-protitles" :class="
						      isShow === index? 'home-protitles-active' : 'home-protitles'
						    ">
								{{ item.titles }}
							</div>
						</div>
						<div class="home-bottom-flex">
							<div class="bottom-text" :class="isShow === index ? 'bottom-textactive' : 'bottom-text'">
								{{ item.leftText }}
							</div>
							<div class="bottom-text" :class="isShow === index ? 'bottom-textactive' : 'bottom-text'">
								{{ item.rightText }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 第四个 -->
			<div class="project-show" v-if="a4===num">
				<div class="home-project" v-for="(item, index) in projectList4" :key="index"
					@mouseover="mouseOverList(index)" @mouseleave="mouseLeaveList(index)">
					<div class="home-project-box" :class="
								  isShow === index? 'home-project-box-active' : 'home-project-box'">
						<div class="home-img-gift"><img :src="item.img" alt="" /></div>
						<div class="projectNames">
							<div class="projectTexts"
								:class="isShow === index  ? 'projectText-active' : 'projectTexts'">
								{{ item.projectNames }}
							</div>
							<div class="home-protitles" :class="
								      isShow === index? 'home-protitles-active' : 'home-protitles'
								    ">
								{{ item.titles }}
							</div>
						</div>
						<div class="home-bottom-flex">
							<div class="bottom-text" :class="isShow === index ? 'bottom-textactive' : 'bottom-text'">
								{{ item.leftText }}
							</div>
							<div class="bottom-text" :class="isShow === index ? 'bottom-textactive' : 'bottom-text'">
								{{ item.rightText }}
							</div>
						</div>
					</div>
				</div>
			</div>



			<!-- 我们的服务 -->
			<div class="home-serve">
				<div class="our-products-box">
					<div class="our-products-titles">我们的服务</div>
					<div class="our-products-english">OUR SERVICES</div>
				</div>

				<div class="ourServe-box">
					<!-- 左侧 -->
					<div class="home-left-serve">
						<div class="serve-box" v-for="(item,index) in serveList" :key="index">
							<div class="serve-imgurl">
								<img :src="item.imgUrl" alt="" />
							</div>
							<div class="serve-item-box">
								<div class="serve-item-titles">
									{{item.servetitles}}
								</div>
								<div class="serve-item-text">
									{{item.servetext}}
								</div>
							</div>

						</div>
					</div>
					<!-- 右侧图片 -->
					<div class="home-right-serve">
						<img :src="imgUrlsy" slt=" /">
					</div>
				</div>
			</div>
			<!-- 客户案例 -->
			<div class="home-kh-case">
				<div class="our-products-box">
					<div class="our-products-titles">客户案例</div>
					<div class="our-products-english">CUSTOMER CASE</div>
				</div>
				<div class="home-project-names">
					<div class="home-case-box" v-for="(item,index) in caseLiset" :key="index"
						@mouseover="mouseOver(index)" @mouseleave="mouseLeave(index)"
						:class="active===index?'homeactive':'home-case-box'">
						<!-- 项目图标 -->
						<div class="home-pro-img">
							<img :src="item.imgUrldree" alt="" />
						</div>
						<!-- 项目名称 -->
						<div class="serve-item-box">
							<div class="serve-item-titles"
								:class="active===index?'serve-item-titactive ':'serve-item-titles'">
								{{item.protitle}}
							</div>
							<div class="serve-item-text"
								:class="active===index?'serve-item-textactive':'serve-item-text'">
								{{item.companynames}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 合作伙伴 -->
		<div class="home-cooperative-partner">
			<div class="home-cooperative-box">
				<div class="our-products-box">
					<div class="our-products-titles">合作伙伴</div>
					<div class="our-products-english">COOPERATIVE PARTNER</div>
				</div>
				<div class="home-cooperative-banner">
					<img src="../../assets/home/sy_t8_banner.png">
				</div>
			</div>
		</div>
		<!-- 联系电话弹窗 -->
		<contactList :isShowBox='isShowBox' @closeFun="closeFun"></contactList>
	</div>

</template>

<script>
	import contactList from '../../components/contactList.vue'
	export default {
		data() {
			return {
				// 联系电话弹窗
				isShowBox:false,
				a1: 1,
				a2: 2,
				a3: 3,
				a4: 4,
				caseLiset: [{
						imgUrldree: require("../../assets/home/sy_t7_logo1.png"),
						protitle: "阳光采购网",
						companynames: "凤凰文化发展公司"
					},
					{
						imgUrldree: require("../../assets/home/sy_t7_logo2.png"),
						protitle: "微商城",
						companynames: "南京凤凰国际书城"
					},
					{
						imgUrldree: require("../../assets/home/sy_t7_logo3.png"),
						protitle: "企业购",
						companynames: "江苏银行"
					},
					{
						imgUrldree: require("../../assets/home/sy_t7_logo4.png"),
						protitle: "阅点点商城",
						companynames: "江苏移动通信"
					},
					{
						imgUrldree: require("../../assets/home/sy_t7_logo5.png"),
						protitle: "短信平台",
						companynames: "江苏省人社厅"
					},
					{
						imgUrldree: require("../../assets/home/sy_t7_logo6.png"),
						protitle: "GIS照明系统",
						companynames: "中电熊猫集团"
					},

				],
				serveList: [{
						imgUrl: require("../../assets/home/sy_dh_zkx.png"),
						servetitles: "为分销商提供稳定供应链",
						servetext: "海量优质商品货源，稳定供货"
					},
					{
						imgUrl: require("../../assets/home/sy_dh_zkx.png"),
						servetitles: "为供货商建立分销渠道",
						servetext: "建立线上分销渠道，增加商品销量，提高供应链效率"
					},
					{
						imgUrl: require("../../assets/home/sy_dh_zkx.png"),
						servetitles: "文化定制",
						servetext: "丰富多样的文化定制活动策划"
					},
				],
				projectList1: [{
						img: require("../../assets/home/sy_t2_1.png"),
						titles: "多门店统一运营解决方案，链接生态链，为连锁门店经营赋能",
						projectNames: "微商城",
						leftText: "统一运营",
						rightText: "链接赋能",
					},

					{
						img: require("../../assets/home/sy_t2_2.png"),
						titles: "为企事业单位提供全新高效的福利采购选择",
						projectNames: "企业购",
						leftText: "福利采购",
						rightText: "全新高效",
					},
					{
						img: require("../../assets/home/sy_t2_3.png"),
						titles: "整合全员营销，聚合、聚集共享资源",
						projectNames: "全员GO",
						leftText: "全员营销",
						rightText: "共享资源",
					},
					{
						img: require("../../assets/home/sy_t2_4.png"),
						titles: "全新零售模式，提供更佳的购物体验",
						projectNames: "自助查询机",
						leftText: "全新模式",
						rightText: "优质体验",
					},

				],
				projectList2: [{
						img: require("../../assets/home/sy_t3_1.png"),
						titles: "支持批量设备添加与控制，场景管理，故障报修等，灵活便捷的管理项目",
						projectNames: "移动端APP",
						leftText: "灵活便捷",
						rightText: "轻松管理",
					},
					{
						img: require("../../assets/home/sy_t3_2.png"),
						titles: "支持可视化、情景化管理，点位图配置，多地项目统一后台管理",
						projectNames: "综合管理后台",
						leftText: "可视化",
						rightText: "情景化",
					},
					{
						img: require("../../assets/home/sy_t3_3.png"),
						titles: "便捷操作，将设备与施工点位图进行绑定，大幅度提升项目施工效率",
						projectNames: "手持端PDA",
						leftText: "提升效率",
						rightText: "操作便捷",
					},
				],
				projectList3: [{
						img: require("../../assets/home/sy_t4_1.png"),
						titles: "拥有会员用户70多万，技术打通全省1000多家新华书店，平台包含120万+册图书，8万+种丰富百货，350+多重生活消费场景",
						projectNames: "阅点点",
						leftText: "图书百货",
						rightText: "生活卡券",
					},
					{
						img: require("../../assets/home/sy_t4_2.png"),
						titles: "为各政企单位提供 文化消费、文化定制 的综合类服务平台。关注文化输出、文化服务，更有中国传统及特色文化的定制化业务延伸",
						projectNames: "千悦福鲤",
						leftText: "文化消费",
						rightText: "分化定制",
					},
				],
				projectList4: [{
					img: require("../../assets/home/sy_t4_1.png"),
					titles: "为企业提供验证码、通知、营销推广等短信服务，全面覆盖、秒级触达、99%到达率；帮助企业迅速开展营销推广、会员管理等活动。平台含三层单位管理体系，可群发、单发短信，具备充值、结算等功能开发",
					projectNames: "短信服务平台",
					leftText: "短信验证",
					rightText: "营销推广",
				}, ],
				SolutionList: [
					"书商一体化解决方案",
					"GIS智慧照明解决方案",
					"SaaS品牌产品",
					"短信服务平台",
				],
				titleData: [{
						imgs: require("../../assets/home/sy_t1_1.png"),
						texts1: "完整精准的",
						texts2: "服务方案",
					},
					{
						imgs: require("../../assets/home/sy_t1_2.png"),
						texts1: "高效快捷的",
						texts2: "产品开发",
					},
					{
						imgs: require("../../assets/home/sy_t1_3.png"),
						texts1: "个性化专享的",
						texts2: "定制服务",
					},
					{
						imgs: require("../../assets/home/sy_t1_4.png"),
						texts1: "长期全面的",
						texts2: "维护更新",
					},

				],


				imgUrl: require("../../assets/home/sy_dh_zkx.png"),
				imgUrlsy: require("../../assets/home/sy_t6_tp.png"),
				num: 1,
				times: "",
				active: 2,
				isShow: "",
			}
		
		},
		components:{
			contactList
		},
		mounted() {
			this.timeFun();
		},
		methods: {
			timerfun() {
				console.log(1111);
				window.clearTimeout(this.times);
			},
			timeFun() {
				this.times = setTimeout(() => {
					this.num++;
					if (this.num == 5) {
						this.num = 1;
					}
					this.timeFun();
				}, 2000);
			},
			// 点击解决方案事件
			solutFun(i) {
				this.num = i + 1;
				this.timerfun();
			},
			//  解决方案事件 标题
			// 鼠标移入
			mouseOverFun(i) {
				this.num = i + 1;
				this.timerfun();
			},
			// 鼠标移除
			mouseLeaveFun(i) {
				this.timeFun();
			},

			mouseOver(index) {
				console.log(11)
				this.active = index
			},
			mouseLeave(index) {
				this.active = null;
			},
			// 项目距盒子
			mouseOverList(index) {
				this.isShow = index
				this.timerfun();
			},
			mouseLeaveList(index) {
				this.isShow = null
				this.timeFun();
			},
			// 点击联系电话
			elasticFun(){
				this.isShowBox=true
			},
			// 关闭弹窗
			closeFun(){
				this.isShowBox=false
			}

		}
	}
</script>
<style lang="scss" scoped>
	.home-banner {
		width: 100%;
		height: 590px;
		background: url(../../assets/home/sy_banner.jpg) no-repeat center;
		margin-top: 88px;

		.home-contactus-box {
			width: 1200px;
			height: 590px;
			margin: 0 auto;
			display: flex;
			align-items: center;
position: relative;
cursor: pointer;
			.home-contactus {
				width: 182px;
				height: 50px;
				background-color: #fff;
				border-radius: 25px;
				text-align: center;
				line-height: 50px;
				font-size: 20px;
				color: #333333;
				margin-top: 120px;
			}
			.programme {
				position: absolute;
				top: 90%;
				display: flex;
			
				.home-view-model {
					width: 280px;
					height: 120px;
					background-color: #ffffff;
					box-shadow: 0px 10px 40px 0px rgba(66, 69, 131, 0.1);
					display: flex;
					margin: 0 30px 0px 0px;
			
					.home-icon-imgs {
						display: flex;
						align-items: center;
						margin: 0 49px 0 29px;
			
						img {
							width: 60px;
							height: 59px;
						}
					}
			
					.home--model-texts {
						display: flex;
						flex-direction: column;
						justify-content: center;
			
						.home-texts1 {
							font-size: 18px;
							line-height: 30px;
							color: #ffba00;
						}
			
						.home-texts2 {
							font-size: 18px;
							line-height: 30px;
							color: #333333;
						}
					}
				}
			}
		}


		
	}

	.our-products {
		width: 1200px;
		margin: 0 auto;

		.our-products-box {
			padding: 132px 0 50px 0;

			.our-products-titles {
				text-align: center;
				font-size: 24px;
				line-height: 30px;
				color: #333333;
				font-weight: bold;
				margin-bottom: -7px;
			}

			.our-products-english {
				width: 323px;
				height: 21px;
				margin: 0px auto;
				font-size: 26px;
				line-height: 30px;
				color: #ffffff;
				text-shadow: #c4c7d1 0px 0px 8px;
				text-align: center;
			}
		}


		.home-Solution-box {
			display: flex;
			justify-content: space-around;

			.suouttext {
				width: 300px;
				font-size: 18px;
				font-weight: bold;
				color: #333333;
				text-align: center;
				cursor: pointer;
			}

			.suouttext-active {
				width: 300px;
				text-align: center;
				font-size: 18px;
				font-weight: bold;
				color: #ffd800;
				cursor: pointer;
			}


			.home-Underline {
				width: 300px;
				height: 4px;
				margin-top: 31px;
				background-color: #ffd800;
				border-radius: 2px;
			}
		}
	}

	.home-back {
		width: 100%;
		padding-top: 44px;
		background-color: #f6f6f8;

		.project-show {
			width: 1200px;
			height: 400px;
			margin: 0 auto;
			display: flex;
			// justify-content: center;
			// flex-wrap: wrap;

			.home-project {
				flex: 1;

				.home-project-box {
					// width: 300px;
					// height: 390px;
					background-image: linear-gradient(to right, #f6f6f8, #fff);
					transition: all 1s linear;

					.home-img-gift {
						text-align: center;
						padding-top: 30px;
					}

					.projectNames {
						text-align: center;

						.projectTexts {
							margin-bottom: 23px;
							font-size: 20px;
							line-height: 30px;
							letter-spacing: 0px;
							color: #333333;
							font-weight: bold;
						}

						.projectText-active {
							margin-bottom: 23px;
							font-size: 20px;
							font-weight: normal;
							font-stretch: normal;
							line-height: 30px;
							letter-spacing: 0px;
							color: #ffba00;
							font-weight: bold;
						}

						.home-protitles {
							padding: 0 38px 0;
							// width: 230px;
							// height: 44px;
							margin: 0 auto;
							text-align: center;
							font-size: 16px;
							color: #999999;
							line-height: 28px;
						}

						.home-protitles-active {
							padding: 0 38px 0;
							// width: 230px;
							// height: 44px;
							text-align: center;
							margin: 0 auto;
							font-size: 16px;
							color: #333333;
							line-height: 28px;
						}
					}

					.home-bottom-flex {
						display: flex;
						justify-content: center;
						// margin-top: 30px;
						padding: 30px 0 37px;

						.bottom-text {
							width: 99px;
							height: 33px;
							background-color: #ffffff;
							border: solid 1px #d6d8dd;
							text-align: center;
							line-height: 33px;
							margin: 0 5px;
							font-size: 14px;
							color: #b2b5bc;
						}

						.bottom-textactive {
							width: 99px;
							height: 33px;
							background-color: #fff;
							border: solid 1px #ffba00;
							text-align: center;
							line-height: 33px;
							margin: 0 5px;
							color: #ffba00;
							font-size: 14px;
						}
					}
				}

				.home-project-box:hover {
					transform: scale(1.1);
				}

				.home-project-box-active {
					// width: 300px;
					// height: 390px;
					background-color: #ffffff;
					box-shadow: 0px 10px 40px 0px rgba(66, 69, 131, 0.1);
				}
			}
		}


		.home-serve {
			width: 1200px;
			margin: 0 auto;

			.our-products-box {
				padding: 71px 0 29px 0;

				.our-products-titles {
					text-align: center;
					font-size: 24px;
					line-height: 30px;
					color: #333333;
					font-weight: bold;
					margin-bottom: -7px;
				}

				.our-products-english {
					width: 323px;
					height: 21px;
					margin: 0px auto;
					font-size: 26px;
					line-height: 30px;
					color: #ffffff;
					text-shadow: #c4c7d1 0px 0px 8px;
					text-align: center;
				}
			}

			.ourServe-box {
				background-color: #ffffff;
				margin: 29px 0 0px;
				display: flex;

				.home-left-serve {
					.serve-box {
						display: flex;
						padding: 63px 68px 0px;

						.serve-imgurl {
							margin-top: 5px;
						}

						.serve-item-box {
							padding: 0 27px;

							.serve-item-titles {
								margin: 0 0 20px;
								font-size: 20px;
								color: #333333;
								font-weight: bold;
							}

							.serve-item-text {
								width: 368px;
								font-size: 16px;
								color: #999999;
							}

						}
					}
				}

				.home-right-serve {
					margin: 35px 87px 58px 123px;

					img {
						width: 511px;
						height: 447px;
					}
				}
			}
		}
	}

	.home-kh-case {
		width: 100%;
		margin-top: 50px;
		background-color: #fff;

		.our-products-box {
			padding: 51px 0 50px 0;

			.our-products-titles {
				text-align: center;
				font-size: 24px;
				line-height: 30px;
				color: #333333;
				font-weight: bold;
				margin-bottom: -7px;
			}

			.our-products-english {
				width: 323px;
				height: 21px;
				margin: 0px auto;
				font-size: 26px;
				line-height: 30px;
				color: #ffffff;
				text-shadow: #c4c7d1 0px 0px 8px;
				text-align: center;
			}
		}

		.home-project-names {
			width: 1200px;
			margin: 0 auto;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;

			.home-case-box {
				width: 382px;
				height: 169px;
				display: flex;
				align-items: center;
				margin-bottom: 25px;
				background-image: url(../../assets/home/sy_t7_bg2.jpg);
				cursor: pointer;

				.home-pro-img {
					margin-left: 35px;
				}

				.serve-item-box {
					margin-left: 25px;

					.serve-item-titles {
						margin: 0 0 23px;
						font-size: 20px;
						color: #333333;
						font-weight: bold;
					}

					.serve-item-titactive {
						margin: 0 0 23px;
						font-size: 20px;
						color: #ffba00;
						font-weight: bold;
					}

					.serve-item-text {
						font-size: 16px;
						color: #999999;
					}


				}
			}

			.homeactive {
				width: 382px;
				height: 169px;
				display: flex;
				align-items: center;
				margin-bottom: 25px;
				background-image: url(../../assets/home/sy_t7_bg1.jpg);
				cursor: pointer;
			}
		}

	}

	.home-cooperative-partner {
		width: 100%;
		margin-top: 27px;
		padding-bottom: 61px;
		background-color: #f6f6f8;

		.home-cooperative-box {
			width: 1200px;
			margin: 0 auto;

			.our-products-box {
				padding: 59px 0 49px 0;

				.our-products-titles {
					text-align: center;
					font-size: 24px;
					line-height: 30px;
					color: #333333;
					font-weight: bold;
					margin-bottom: -7px;
				}

				.our-products-english {
					width: 323px;
					height: 21px;
					margin: 0px auto;
					font-size: 26px;
					line-height: 30px;
					color: #ffffff;
					text-shadow: #c4c7d1 0px 0px 8px;
					text-align: center;
				}
			}

		}
	}
</style>



// WEBPACK FOOTER //
// src/views/homepages/homepages.vue